import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleCollectionFetchPending,
  handleCollectionFetchRejected,
  handleCollectionFetchFulfilled,
} from "redux/helpers/fetching"
import { fetchPaymentMethods } from "redux/features/payment_methods/paymentMethodsThunk"

const paymentMethodsAdapter = createEntityAdapter()
export const initialState = paymentMethodsAdapter.getInitialState({
  fetchCollectionStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const paymentMethodsSlice = createSlice({
  name: "payment-methods",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchPaymentMethods.pending, (state) =>
        handleCollectionFetchPending(state),
      )
      .addCase(fetchPaymentMethods.rejected, (state) =>
        handleCollectionFetchRejected(state),
      )
      .addCase(fetchPaymentMethods.fulfilled, (state, { payload }) => {
        paymentMethodsAdapter.setAll(state, payload.banks)
        handleCollectionFetchFulfilled(state)
      })
  },
})

export const { selectAll: selectPaymentMethods } =
  paymentMethodsAdapter.getSelectors(
    (state: RootState) => state.features.payment_methods,
  )
export const selectFetchCollectionStatus = (state: RootState) =>
  state.features.payment_methods.fetchCollectionStatus

export default paymentMethodsSlice.reducer
